<div class="page-body" *ngIf="user">
  <div class="row">
    <div class="col-sm-6">
      <div>
        <app-card [title]="'admin.dealer.account.my_information'|translate"
                  [cardOptionBtnValue]="'global.edit'|translate"
                  [cardOptionBtn]="true" (outputButton)="openManageUserModal(user,true)">
          <div class="row">
            <div class="col-sm-6">
              <p class="text-muted m-b-10">{{'doctrine.user.firstName'|translate}}</p>
              <label class="m-b-15">{{user.firstName}}</label>
            </div>
            <div class="col-sm-6">
              <p class="text-muted m-b-10">{{'doctrine.user.lastName'|translate}}</p>
              <label class="m-b-15">{{user.lastName}}</label>
            </div>
            <div class="col-sm-6">
              <p class="text-muted m-b-10">{{'doctrine.user.username'|translate}}</p>
              <label class="m-b-15">{{user.username}}</label>
            </div>
            <div class="col-sm-6">
              <p class="text-muted m-b-10">{{'doctrine.user.email'|translate}}</p>
              <label class="m-b-15">{{user.email}}</label>
            </div>
          </div>
          <div *ngIf="isAdmin" class="card-block-hid ng-trigger ng-trigger-cardToggle" style="overflow: hidden;">
            <button class="btn btn-primary ripple light"
                    type="button"
                    (click)="changePasswordModal.show()">
              {{'admin.dealer.account.change_password'|translate}}
            </button>
          </div>
        </app-card>
      </div>
    </div>
    <div class="col-sm-6">
      <div *ngIf="isAdmin">
        <app-card [title]="'admin.dealer.account.setting_title'|translate"
                  [cardOptionBtnValue]="'global.edit'|translate"
                  [cardOptionBtn]="isAdmin" (outputButton)="openManageAllowPartialOrderModal(user.isAllowedPartialPaid, user.id)">
          <div class="row">
            <div class="col-sm-6">
              <p class="text-muted m-b-10">{{'doctrine.user.allow_partial_order_description'|translate}}</p>
              <label *ngIf="user.isAllowedPartialPaid" class="m-b-15">{{'doctrine.user.allow_partial_order' | translate}}</label>
              <label *ngIf="!user.isAllowedPartialPaid" class="m-b-15">{{'doctrine.user.not_allow_partial_order' | translate}}</label>
            </div>
          </div>
        </app-card>
      </div>
      <div *ngIf="!isAdmin">
        <app-card [title]="'admin.dealer.account.reset_password_title'|translate">
          <div class="card-block-hid ng-trigger ng-trigger-cardToggle" style="overflow: hidden;">
            <button class="btn btn-primary ripple light"
                    type="button"
                    (click)="changePasswordModal.show()">
              {{'admin.dealer.account.change_password'|translate}}
            </button>
          </div>
        </app-card>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <div *ngIf="isAdmin">
        <app-card [advanceButton]="true"
                  [cardOptionBtnValue]="'admin.dealer.account.add_user'|translate"
                  [cardOptionBtn]="true" (outputButton)="openManageUserModal(null, false)"
                  [title]="(( archive ? 'admin.dealer.account.users_archive' : 'global.users')|translate) + ' (' + totalUsers + ')'">
          <app-grid [grid]="grid" (totalCount)="setTotalUsersCount($event)"></app-grid>
          <button class="btn btn-primary ripple light pull-right my-3" type="button" (click)="switchShowArchive()">
            {{ (archive ? 'admin.dealer.account.show_users' : 'admin.dealer.account.show_deleted_users')|translate}}
          </button>
        </app-card>
      </div>
    </div>
  </div>
</div>

<app-modal-basic #changePasswordModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">
      {{'admin.dealer.account.change_password' | translate}}
    </h4>
    <button type="button" class="close basic-close" (click)="changePasswordModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{'validators.password.info' | translate}}</p>
    <form novalidate #changePasswordForm="ngForm">
      <div class="form-row row">
        <div class="form-group col-md-6">
          <label for="currentPassword">{{'admin.dealer.account.current_password'|translate}} *</label>
          <input required minlength="8" name="currentPassword"
                 id="currentPassword"
                 type="password"
                 #password="ngModel"
                 class="form-control"
                 [(ngModel)]="changePasswordModel.currentPassword">
          <span class="form-bar"></span>
          <div class="messages text-danger"
               *ngIf="password.invalid && password.dirty && password.errors?.required">{{'errors.required'|translate}}{{password.invalid && password.dirty}}</div>
        </div>
      </div>
      <div class="form-row row">
        <div class="form-group col-md-6">
          <label for="newPassword">{{'admin.dealer.account.new_password'|translate}} *</label>
          <input required minlength="8" maxLength="256" strength  name="password"
                 id="newPassword"
                 type="password"
                 #newPassword="ngModel"
                 class="form-control"
                 [(ngModel)]="changePasswordModel.password">
          <span class="form-bar"></span>
          <div class="messages text-danger"
               *ngIf="newPassword.invalid && newPassword.dirty && newPassword.errors?.required">{{'errors.required'|translate}}
          </div>
          <div class="messages text-danger" *ngIf="newPassword.dirty &&  newPassword.errors?.strength">
            {{newPassword.errors?.strength.value | translate}}
          </div>
        </div>
        <div class="form-group col-md-6">
          <label for="confirmPassword">{{'admin.dealer.account.confirm_new_password'|translate}} *</label>
          <input required minlength="8" name="confirm"
                 id="confirmPassword"
                 type="password"
                 #confirmation="ngModel"
                 class="form-control"
                 [(ngModel)]="changePasswordModel.passwordConfirmation">
          <span class="form-bar"></span>
          <div class="messages text-danger"
               *ngIf="confirmation.invalid && confirmation.dirty && confirmation.errors && confirmation.errors['required']">{{'errors.required'|translate}}</div>
          <div class="messages text-danger"
               *ngIf="confirmation.dirty && changePasswordModel.password !== changePasswordModel.passwordConfirmation">{{'auth.reset_password.confirm_password.notequal'|translate}}
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="changePasswordModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" [ngClass]="{'btn-disabled': !changePasswordForm.valid, 'disabled': !changePasswordForm.valid}" [disabled]="!changePasswordForm.valid" (click)="changePassword()">
      {{'global.actions.save' | translate}}
    </button>
  </div>
</app-modal-basic>

<app-manage-user
  *ngIf="showManageUserModal"
  [refresh]="refreshModal"
  [showModal]="showManageUserModal"
  [userInput]="editingUser"
  [manageProfile]="manageProfile"
  (notifyParent)="refreshGrid($event)">
</app-manage-user>

<app-modal-basic #deleteModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'User'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}: <span [innerHTML]="fullName"></span></p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="softDelete()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>

<app-modal-basic #reAddModal >
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_readd_title' | translate:{entity: 'User'} }}</h4>
    <button type="button" class="close basic-close" (click)="reAddModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_readd_body' | translate}}: <span [innerHTML]="fullName"></span></p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-default ripple me-4" (click)="reAddModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="reAdd()">{{'global.actions.readd'|translate}}</button>
  </div>
</app-modal-basic>

<app-modal-basic #allowPartialOrderModal >
  <div class="app-modal-header">

    <h4 class="modal-title">{{'admin.dealer.show.setting' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="allowPartialOrderModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #allowPartialOrderForm="ngForm">
      <div class="form-row row">
        <div class="form-group col-md-12">
          <label>{{'doctrine.user.allow_partial_order_description' | translate}} <span class="star">*</span></label>
          <ng-select [items]="allowItems"
                     bindLabel="label"
                     [addTag]="false"
                     [hideSelected]="true"
                     name="isAllowedPartialPaid"
                     [(ngModel)]="isAllowedPartialPaid"
                     [clearable]="false"
                     [searchable]="false">
          </ng-select>
          <span class="form-bar"></span>
        </div>
      </div>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="allowPartialOrderModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="submit" class="btn btn-primary ripple light" (click)="manageAllowPartialPaid()"
            [disabled]="!allowPartialOrderForm.valid">
      {{'global.actions.save' | translate}}
    </button>
  </div>
</app-modal-basic>
